import { Injectable, inject } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { AuthenticationService } from './student-authentication.service';

@Injectable()
export class UserService {
  private authService = inject(AuthenticationService);

  private claims: any;
  private reverifyEmail: string;
  user = {
    username: '',
    password: '',
    code: '',
  };

  constructor() {
    this.setClaims();
  }

  public setClaims() {
    if (localStorage.getItem('idToken') != null) {
      this.claims = jwtDecode(localStorage.getItem('idToken'));
      this.reverifyEmail = this.claims['custom:reverifyEmail'];
    }
  }

  public getClaims(): any {
    return this.claims;
  }

  public setUser(email: string) {
    this.user.username = email;
  }

  public getReverifyEmail(): any {
    return this.reverifyEmail;
  }


}
